// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lLNTIqw9OTUdBg0vgWvA{width:100%}.F1dBLR_SypwWva05ERUZ{align-items:flex-start;margin-top:40px}.URa4xcoTswv2nJMbJ_mW{align-items:flex-start;margin-top:24px}.QdrlDn2tlrEotQPPvWPA{flex-direction:column;gap:16px;display:flex}._VffpK7fORIbwqj_q0TQ{color:var(--content-primary-tertiary);margin:0;padding-left:20px;list-style:outside}.MSfAc8SkBlU2LVUjWu1U{color:var(--content-brand-primary);text-decoration:none}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `lLNTIqw9OTUdBg0vgWvA`,
	"firstCheckbox": `F1dBLR_SypwWva05ERUZ`,
	"checkbox": `URa4xcoTswv2nJMbJ_mW`,
	"termsLabel": `QdrlDn2tlrEotQPPvWPA`,
	"disclosures": `_VffpK7fORIbwqj_q0TQ`,
	"link": `MSfAc8SkBlU2LVUjWu1U`
};
export default ___CSS_LOADER_EXPORT___;
